import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ArrowRight } from "lucide-react";
import { faqs } from "@/config/site";

const WhatsAppGlyph = () => null;

function FAQItem({ q, a, idx }) {
  const [open, setOpen] = useState(idx === 0);
  return (
    <div className="border-b border-hairline last:border-b-0" data-testid={`faq-item-${idx}`}>
      <button
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="w-full flex items-center justify-between gap-4 py-5 text-left group"
      >
        <span className="text-lg md:text-xl font-semibold text-ink leading-snug group-hover:text-brand transition-colors">
          {q}
        </span>
        <ChevronDown
          className={`h-5 w-5 text-brand shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
          strokeWidth={2}
        />
      </button>
      <div
        className={`grid transition-all duration-300 ease-out ${
          open ? "grid-rows-[1fr] pb-5" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden">
          <p className="text-ink-body leading-relaxed max-w-3xl">{a}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQ() {
  return (
    <>
      <section
        className="text-white"
        style={{ background: "linear-gradient(105deg,#0F2B46 0%,#196CA3 100%)" }}
      >
        <div className="mx-auto max-w-site px-5 lg:px-8 py-16 lg:py-20">
          <div className="rule" style={{ background: "#4FC3F7" }} />
          <div className="eyebrow !text-brand-light">FAQ</div>
          <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold leading-tight tracking-tight max-w-3xl">
            The things Indian businesses ask us most.
          </h1>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-3xl px-5 lg:px-8 py-16">
          <div>
            {faqs.map((f, i) => (
              <FAQItem key={i} q={f.q} a={f.a} idx={i} />
            ))}
          </div>

          <div className="mt-14 rounded-card bg-brand-card p-8 text-center">
            <h2 className="text-2xl font-bold text-ink">Still got questions?</h2>
            <p className="mt-2 text-ink-body">
              Send us your details and we'll come back to you within a day.
            </p>
            <Link
              to="/get-started"
              className="mt-5 inline-flex items-center gap-2 rounded-md text-white px-6 py-3 font-semibold text-sm shadow-card-soft hover:shadow-card-lift hover:-translate-y-px transition-all"
              style={{ background: "linear-gradient(100deg,#1D6C35 0%,#2C994D 100%)" }}
              data-testid="faq-cta"
            >
              Start the conversation
              <ArrowRight className="h-4 w-4" strokeWidth={2.4} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
